import request from "@/utils/request";

// 列表(主数据列表)
export function loadCallBackBillListDataApi(data) {
    return request({
      url: "web/callBackBill/listData",
      method: "post",
      data
    });
  }
  
  // 导出(主数据列表)
  export function loadCallBackBillExportDataApi(data) {
    return request({
      url: "web/callBackBill/exportData",
      method: "post",
      data
    });
  }
  
  // 新增修改
  export function saveOrUpdateCallBackBillApi(data) {
    return request({
      url: "web/callBackBill/saveOrUpdate",
      method: "post",
      data
    });
  }
  
  // 初始化
  export function initCallBackBillApi(data) {
    return request({
      url: "web/callBackBill/init",
      method: "post",
      data
    });
  }
  
  // 待回访的数据
  export function loadCallBackPendingListDataApi(data) {
    return request({
      url: "web/callBackPending/listData",
      method: "post",
      data
    });
  }
  
  // 待回访的数据数量
  export function findCallBackPendingTaskCountApi(data) {
    return request({
      url: "web/callBackPending/findTaskCount",
      method: "post",
      data
    });
  }